export class DBManager {
    private static dbConnection: IDBDatabase | null = null;

    private static async openDBConnection(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const openDBRequest = indexedDB.open("MyDatabase");

            openDBRequest.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                if (!db.objectStoreNames.contains("contacts"))
                    db.createObjectStore("contacts", { keyPath: "contactId" });

                if (!db.objectStoreNames.contains("dmTinh"))
                    db.createObjectStore("dmTinh", { keyPath: "tinhId" })

                if (!db.objectStoreNames.contains("dmDai"))
                    db.createObjectStore("dmDai", { keyPath: "daiId" })

                if (!db.objectStoreNames.contains("userDaiConfigPredef"))
                    db. createObjectStore("userDaiConfigPredef", { keyPath: ["tinhId", "thu"] })
                if (!db.objectStoreNames.contains("userDaiConfig"))
                    db.createObjectStore("userDaiConfig", { keyPath: ["tinhId", "thu"] })
                if (!db.objectStoreNames.contains("daiNgayQuay"))
                    db.createObjectStore("daiNgayQuay", { keyPath: ["thu", "daiId"] })
                if (!db.objectStoreNames.contains("userConfig"))
                    db.createObjectStore("userConfig", { keyPath: "tinhId" })
                if (!db.objectStoreNames.contains("contactsConfigPredef"))
                    db.createObjectStore("contactsConfigPredef", { keyPath: "tinhId" })
                if (!db.objectStoreNames.contains("chats"))
                    db.createObjectStore("chats", { keyPath: "id" })
                if (!db.objectStoreNames.contains("messages")) {
                    const objStore = db.createObjectStore("messages", { keyPath: ["chatId", "id"] })
                    objStore.createIndex("chatId_index", "chatId")
                }

                if (!db.objectStoreNames.contains("messagesParsed"))
                    db.createObjectStore("messagesParsed", { keyPath: ["chatId", "id"] })
                if (!db.objectStoreNames.contains("deletedMessages")) {
                    const objStore = db.createObjectStore("deletedMessages", { keyPath: ["chatId", "id"] })
                    objStore.createIndex("chatId_index", "chatId")
                }
                if (!db.objectStoreNames.contains("editedMessages")) {
                    const objStore = db.createObjectStore("editedMessages", { keyPath: ["chatId", "id", "editDate"] })
                    objStore.createIndex("chatId_index", "chatId")
                }
                if (!db.objectStoreNames.contains("tuKhoaRieng"))
                    db.createObjectStore("tuKhoaRieng", { keyPath: ["userId", "mienCuPhapId","tuKhoa"] })
            };

            openDBRequest.onsuccess = (event) => {
                this.dbConnection = (event.target as IDBOpenDBRequest).result;
                resolve(this.dbConnection);
            };

            openDBRequest.onerror = (event) => {
                reject((event.target as IDBTransaction).error);
            };
        });
    }

    public static async getDBConnection(): Promise<IDBDatabase> {
        if (this.dbConnection) {
            // Nếu kết nối đã được thiết lập, trả về ngay kết nối hiện tại
            return this.dbConnection;
        } else {
            // Nếu chưa có kết nối, mở kết nối mới
            return this.openDBConnection();
        }
    }
    public static async saveDanhMucToObjectStore(payload: any): Promise<any> {
        const db = await this.getDBConnection();
        const { dmDai, dmTinh, userDaiConfigPredef, daiNgayQuay, userConfig,
            contactsConfigPredef, userDaiConfig, tuKhoaRieng } = payload;
        //dmTinh
        let transaction = db.transaction("dmTinh", "readwrite");
        let objectStore = transaction.objectStore("dmTinh");
        dmTinh.map((item: any) => {
            objectStore.put(item)
        })
        //dmDai
        transaction = db.transaction("dmDai", "readwrite");
        objectStore = transaction.objectStore("dmDai");
        dmDai.map((item: any) => {
            objectStore.put(item)
        })
        //userDaiConfigPredef
        transaction = db.transaction("userDaiConfigPredef", "readwrite");
        objectStore = transaction.objectStore("userDaiConfigPredef");
        userDaiConfigPredef && userDaiConfigPredef.map((item: any) => {
            objectStore.put(item)
        })
        //userDaiConfig
        transaction = db.transaction("userDaiConfig", "readwrite");
        objectStore = transaction.objectStore("userDaiConfig");
        userDaiConfig.map((item: any) => {
            objectStore.put(item)
        })
        //daiNgayQuay
        transaction = db.transaction("daiNgayQuay", "readwrite");
        objectStore = transaction.objectStore("daiNgayQuay");
        daiNgayQuay.map((item: any) => {
            objectStore.put(item)
        })
        //userConfig
        transaction = db.transaction("userConfig", "readwrite");
        objectStore = transaction.objectStore("userConfig");
        userConfig.map((item: any) => {
            objectStore.put(item)
        })
        //contactsConfigPredef
        transaction = db.transaction("contactsConfigPredef", "readwrite");
        objectStore = transaction.objectStore("contactsConfigPredef");
        contactsConfigPredef.map((item: any) => {
            objectStore.put(item)
        })
        //tuKhoaRieng
        transaction = db.transaction("tuKhoaRieng", "readwrite");
        objectStore = transaction.objectStore("tuKhoaRieng");
        objectStore.clear()
        tuKhoaRieng?.map((item: any) => {
            objectStore.put(item)
        })
        

    }
    public static readDataByPrimarykey(tableName: string, primaryKey: string | any[]): Promise<any> {
        return new Promise((resolve, reject) => {
            DBManager.getDBConnection().then(db => {
                let trans = db.transaction(tableName, "readonly")
                let objStore = trans.objectStore(tableName);
               

                const request = objStore.getAll(primaryKey);

                const data: any = [];

                request.onsuccess = function (event) {
                    const cursor = request.result;
                    cursor.map(item => {
                        data.push(item)
                    })

                    resolve(data)
                    //trans.commit()
                };

                request.onerror = function (event:any) {
                    reject(event.target.error);
                    //trans.commit()
                };
            });
        });
    }
    public static readDataAllFromTable(tableName: string): Promise<any[]> {
        return new Promise((resolve, reject) => {
            DBManager.getDBConnection().then(db => {
                let trans = db.transaction(tableName, "readonly")
                let objStore = trans.objectStore(tableName);              

                const request = objStore.getAll();

                const data: any = [];

                request.onsuccess = function (event) {
                    const cursor = request.result;
                    cursor.map(item => {
                        data.push(item)
                    })

                    resolve(data)
                    //trans.commit()
                };

                request.onerror = function (event:any) {
                    reject(event.target.error);
                    //trans.commit()
                };
            });
        });
    }
    public static readDataByIndex(tableName: string, valueToFind: string | any[], indexFieldName: string): Promise<any[]> {
        return new Promise((resolve, reject) => {
            DBManager.getDBConnection().then(db => {
                let trans = db.transaction(tableName, "readonly")
                let objStore = trans.objectStore(tableName);

                // Tạo một phạm vi key với giá trị cụ thể cho key1 và key2
                var keyRange = IDBKeyRange.only([valueToFind]); // [1, 2] là key1 và key2
                const request = objStore.index(indexFieldName).getAll(valueToFind);
                const data: any[] = [];

                request.onsuccess = function (event) {
                    const cursor = request.result;
                    cursor.map(item => {
                        data.push(item)
                    })

                    resolve(data)
                    //trans.commit()
                };

                request.onerror = function (event:any) {
                    reject(event.target.error);
                    //trans.commit()
                };
            });
        });
    }
}
export function deleteDatabase() {
    const dbName = "MyDatabase"
    var request = indexedDB.open(dbName);

    request.onsuccess = function (event: any) {
        var db = event.target.result;

        // Đóng mọi kết nối mà bạn có thể có với cơ sở dữ liệu trước khi xóa
        db.close();

        // Xóa cơ sở dữ liệu
        var deleteRequest = indexedDB.deleteDatabase(dbName);

        deleteRequest.onsuccess = function () {
            console.log("Cơ sở dữ liệu đã được xóa thành công");
        };

        deleteRequest.onerror = function (event: any) {
            console.error("Lỗi khi xóa cơ sở dữ liệu:", event.target.error);
        };
    };

    request.onerror = function (event: any) {
        console.error("Lỗi khi mở cơ sở dữ liệu:", event.target.error);
    };
}
// Sử dụng trong ứng dụng
/* DBManager.getDBConnection()
    .then((dbConnection) => {
        // Kết nối đã được mở và có thể sử dụng dbConnection trong toàn bộ ứng dụng
        // Ví dụ: thêm bản ghi vào object store
        const transaction = dbConnection.transaction("Customers", "readwrite");
        const objectStore = transaction.objectStore("Customers");
        const customerData = { id: 1, name: "John Doe", email: "john@example.com" };
        objectStore.add(customerData);

        transaction.oncomplete = () => {
            console.log("Thêm bản ghi thành công!");
        };

        transaction.onerror = (event) => {
            console.error("Lỗi khi thêm bản ghi: ", (event.target as IDBTransaction).error);
        };
    })
    .catch((error) => {
        console.error("Lỗi khi mở kết nối: ", error);
    });
 */